import { useState } from "react"

const useFilterAccordions = <T extends {}>(initialAccordions: T) => {
    const [expandedAccordions, setExpandedAccordions] = useState<T>(initialAccordions)

    const toggleAccordion = (accordion: keyof T) => {
        setExpandedAccordions((prev) => ({
            ...prev,
            [accordion]: !prev[accordion],
        }))
    }

    return {
        expandedAccordions,
        toggleAccordion,
    }
}

export default useFilterAccordions
